import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,2.2519531 c -5.3848346,0 -9.75,4.3651454 -9.75,9.7499999 0,5.383895 4.3652254,9.748047 9.75,9.748047 5.384795,0 9.75,-4.364152 9.75,-9.748047 0,-5.3848545 -4.365205,-9.7499999 -9.75,-9.7499999 z m 0,1.5 c 4.556395,0 8.25,3.6935746 8.25,8.2499999 C 20.25,16.557249 16.556495,20.25 12,20.25 7.4435446,20.25 3.75,16.557249 3.75,12.001953 3.75,7.4455277 7.4435946,3.7519531 12,3.7519531 Z"
	})]
});
export default SvgCircleLine;
